import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
const Index = () => import('views/activity/shop/index');
const Search = () => import('views/activity/shop/search');
const SearchResult = () => import('views/activity/shop/searchResult');
const GoodDetails = () => import('views/activity/shop/goodDetails');
const ShopCart = () => import('views/activity/shop/shopCart');
const Logistics = () => import('views/activity/shop/logistics');
const ConfirmOrder = () => import('views/activity/shop/confirmOrder');
const PayResult = () => import('views/activity/shop/payResult');
const AddressManage = () => import('views/activity/shop/addressManage');
const AddAddress = () => import('views/activity/shop/addAddress');
const Order = () => import('views/activity/shop/order');
const Refund = () => import('views/activity/shop/refund');
const OrderDetail = () => import('views/activity/shop/orderDetail');
const EncyclopediaList = () => import('views/activity/encyclopedia/encyclopediaList');
const EncyclopediaDetail = () => import('views/activity/encyclopedia/encyclopediaDetail');
const WikiEncyDetails = () => import('views/activity/encyclopedia/wikiEncyDetails');
const Protocol = () => import('views/activity/protocol');
const Secrete = () => import('views/activity/secrete');
const Unsubscribe = () => import('views/activity/unsubscribe');
const AboutUs = () => import('views/activity/aboutUs');
const ServiceJump = () => import('views/activity/serviceJump');
const HealthCenter = () => import('views/activity/healthCenter/healthCenter?2');
const ClubDetail = () => import('views/activity/healthCenter/clubDetail?1');
const Map = () => import('views/activity/healthCenter/map');
const FreeHealthTest = () => import('views/checkPoint/freeHealthTest');
const CheckPointPage = () => import('views/checkPoint/checkPointPage');
const Tmap = () => import('views/checkPoint/Tmap');
const TCmap = () => import('views/checkPoint/TCmap');
const ProjectDetails = () => import('views/activity/healthCenter/projectDetails');
const PlaceOrder = () => import('views/activity/healthCenter/placeOrder');
const PayProjectResult = () => import('views/activity/healthCenter/payProjectResult.vue')
const ProjectOrder = () => import('views/activity/healthCenter/projectOrder.vue')
const ProjectOrderDetail = () => import('views/activity/healthCenter/projectOrderDetail.vue')
const AdvertisementPage = () => import('views/advertisement/advertisementPage.vue')
const Record = () => import('views/record/record.vue')
const HealthAdvice = () => import('views/record/healthAdvice.vue')
const Upload = () => import('views/record/upload.vue')
const UploadResults = () => import('views/record/uploadResults.vue')
const AIUrl = () => import('views/activity/AIUrl.vue')
const Chat = () => import('views/activity/chat.vue')

const Full = () => import('views/containers/Full')

export default new Router({
  mode: 'history',
  base: '/',
  component: Full,
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        title: '商城',
        keepAlive: true
      },
      component: Index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '关于我们'
      },
      component: AboutUs
    },
    {
      path: '/logistics',
      name: 'logistics',
      meta: {
        title: '物流信息'
      },
      component: Logistics
    },
    {
      path: '/payResult',
      name: 'payResult',
      meta: {
        title: '支付结果'
      },
      component: PayResult
    },
    {
      path: '/refund',
      name: 'refund',
      meta: {
        title: '申请退款'
      },
      component: Refund
    },
    {
      path: '/serviceJump',
      name: 'serviceJump',
      meta: {
        title: ''
      },
      component: ServiceJump
    },
    {
      path: '/map',
      name: 'Tmap.vue',
      meta: {
        title: '门店地图'
      },
      component: Map
    },
    {
      path: '/healthCenter',
      name: 'healthCenter',
      meta: {
        title: '健康中心',
        keepAlive: false
      },
      component: HealthCenter
    },
    {
      path: '/ClubDetail',
      name: 'ClubDetail',
      meta: {
        title: '门店详情'
      },
      component: ClubDetail
    },
    {
      path: '/projectDetails',
      name: 'projectDetails',
      meta: {
        title: '项目详情'
      },
      component: ProjectDetails
    },
    {
      path: '/placeOrder',
      name: 'placeOrder',
      meta: {
        title: '填写订单'
      },
      component: PlaceOrder
    },
    {
      path: '/payProjectResult',
      name: 'payProjectResult',
      meta: {
        title: '订单结果'
      },
      component: PayProjectResult
    },
    {
      path: '/projectOrder',
      name: 'projectOrder',
      meta: {
        title: '服务订单'
      },
      component: ProjectOrder
    },
    {
      path: '/projectOrderDetail',
      name: 'projectOrderDetail',
      meta: {
        title: '订单详情'
      },
      component: ProjectOrderDetail
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: '搜索'
      },
      component: Search
    },
    {
      path: '/searchResult',
      name: 'searchResult',
      meta: {
        title: '搜索结果'
      },
      component: SearchResult
    },
    {
      path: '/goodDetails',
      name: 'goodDetails',
      meta: {
        title: '商品详情'
      },
      component: GoodDetails
    },
    {
      path: '/shopCart',
      name: 'shopCart',
      meta: {
        title: '购物车'
      },
      component: ShopCart
    },
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      meta: {
        title: '填写订单'
        // keepAlive: true
      },
      component: ConfirmOrder
    },
    {
      path: '/addressManage',
      name: 'addressManage',
      meta: {
        title: '地址管理'
        // keepAlive: true
      },
      component: AddressManage
    },
    {
      path: '/addAddress',
      name: 'addAddress',
      meta: {
        title: '新增收货地址'
      },
      component: AddAddress
    },
    {
      path: '/order',
      name: 'order',
      meta: {
        title: '商品订单'
      },
      component: Order
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        title: '订单详情'
      },
      component: OrderDetail
    },
    {
      path: '/encyclopediaList',
      name: 'encyclopediaList',
      meta: {
        title: '健康百科'
      },
      component: EncyclopediaList
    },
    {
      path: '/wikiEncyDetails',
      name: 'wikiEncyDetails',
      meta: {
        title: '百科'
      },
      component: WikiEncyDetails
    },
    {
      path: '/encyclopediaDetail',
      name: 'encyclopediaDetail',
      meta: {
        title: '详情'
      },
      component: EncyclopediaDetail
    },
    {
      path: '/protocol',
      name: 'protocol',
      meta: {
        title: '用户协议'
      },
      component: Protocol
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      meta: {
        title: '账号注销协议'
      },
      component: Unsubscribe
    },
    {
      path: '/secrete',
      name: 'secrete',
      meta: {
        title: '隐私政策'
      },
      component: Secrete
    },
    {
      path: '/freeHealthTest',
      name: 'freeHealthTest',
      meta: {
        title: '免费健康检测'
      },
      component: FreeHealthTest
    },
    {
      path: '/checkPointPage',
      name: 'checkPointPage',
      meta: {
        title: '免费健康检测点地图'
      },
      component: CheckPointPage
    },
    {
      path: '/Tmap',
      name: 'Tmap',
      meta: {
        title: '地图'
      },
      component: Tmap
    },
    {
      path: '/TCmap',
      name: 'TCmap',
      meta: {
        title: '地图'
      },
      component: TCmap
    },
	  {
	  path: '/AdvertisementPage',
	  name: 'AdvertisementPage',
	  meta: {
	    title: '广告页'
	  },
	  component: AdvertisementPage
	  },
    {
      path: '/Record',
      name: 'Record',
      meta: {
        // title: '体重记录',
        keepAlive: true
      },
      component: Record
    },
    {
      path: '/HealthAdvice',
      name: 'HealthAdvice',
      meta: {
        title: '健康建议'
      },
      component: HealthAdvice
    },
    {
      path: '/Upload',
      name: 'Upload',
      meta: {
        title: '上传体质指数(BMI)'
      },
      component: Upload
    },
    {
      path: '/UploadResults',
      name: 'UploadResults',
      meta: {
        title: '上传结果'
      },
      component: UploadResults
    },
    {
      path: '/AIUrl',
      name: 'AIUrl',
      meta: {
        title: '小康知道'
      },
      component: AIUrl
    },
    {
      path: '/chat',
      name: 'chat',
      meta: {
        title: 'AI搜索'
      },
      component: Chat
    }
  ]
})
